<script>
    import * as animateScroll from "svelte-scrollto";
    import {onMount} from 'svelte';

    export let handleClickNav;
    import Icon from 'fa-svelte';
    import {faSortUp} from '@fortawesome/free-solid-svg-icons/faSortUp';
    import {faSortDown} from '@fortawesome/free-solid-svg-icons/faSortDown';
    import CVSTable from '../table.svelte';
    import DocumentedProjects from '../DocumentedProjects.svelte';

    export let subSelection;
    export let handleClickRegisterProyect;

    let docuProj = null;

    let up1 = true;
    let up2 = true;
    let up3 = true;
    let up4 = true;
    let up5 = true;

    let handleClickArrow1 = () => {
        up1 = !up1;
        up2 = true;
        up3 = true;
        up4 = true;
        up5 = true;
    }
    let handleClickArrow2 = () => {
        up2 = !up2;
        up1 = true;
        up3 = true;
        up4 = true;
        up5 = true;
    }
    let handleClickArrow3 = () => {
        up3 = !up3;
        up1 = true;
        up2 = true;
        up4 = true;
        up5 = true;
    }
    let handleClickArrow4 = () => {
        up4 = !up4;
        up3 = true;
        up1 = true;
        up2 = true;
        up5 = true;

        if (docuProj != null && docuProj.table != null) {
            docuProj.table.columns.adjust().draw();
            console.log(docuProj.table.columns);
        }
    }
    let handleClickArrow5 = () => {
        up3 = true;
        up1 = true;
        up2 = true;
        up4 = true;
        up5 = !up5;
    }

    let proyectsInProcess;

    onMount(async () => {

        const proxyurl = "";
        const url = 'https://plataforma.cvschile.cl/site/precertified-projects';

        try {
            const response = await fetch(proxyurl + url)
            proyectsInProcess = await response.json();
        } catch (error) {
            console.log(error);
        }

    });

    let proyectsDS19;

    onMount(async () => {

        const proxyurl = "";
        const url = 'https://plataforma.cvschile.cl/site/ds19-projects';

        try {
            const response = await fetch(proxyurl + url)
            proyectsDS19 = await response.json();
        } catch (error) {
            console.log(error);
        }

    });

    let proyectsCertified;

    onMount(async () => {

        const proxyurl = "";
        const url = 'https://plataforma.cvschile.cl/site/certified-projects';

        try {
            const response = await fetch(proxyurl + url)
            proyectsCertified = await response.json();
        } catch (error) {
            console.log(error);
        }

    });

    onMount(async () => {
        if (subSelection == 0) animateScroll.scrollToTop();
        else animateScroll.scrollTo({element: '#about-section-' + subSelection, offset: -80});
    });

</script>

<div class="row">

    <div class="col-12 white-bg" style="overflow:hidden;min-height: 100vh;">
        <img src="./img/background-A.svg" alt="" class="background-right disabe-img" style="height: 100vh;">
        <div class="row">
            <img src="./img/register/stamp-asesor.png" alt="" class="reg-img-base04 disabe-img">
            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix">

                <h2 class="text-content title-content section-cvs" style="margin: 20px 0 0 0;"> REGISTRO </h2>
                <hr class="underline-content">

                <div id="accordionReg" class="flex-arrow">
                    <div class="card">
                        <div on:click={handleClickArrow4} class="card-header clickable" id="headingRegFour"
                             style="padding:0;" data-toggle="collapse" data-target="#collapseRegFour"
                             aria-expanded="true" aria-controls="collapseRegFour">
                            <h2 style="margin:0;padding:0;">
                                <button class="btn btn-link dropdown-header">
                                    PROYECTOS REGISTRADOS
                                </button>
                                <div class="sort-arrow">
                                    {#if up4 === false}
                                        <Icon class="arrow-top" icon={faSortUp}></Icon>{/if}
                                    {#if up4 === true}
                                        <Icon class="arrow-bot" icon={faSortDown}></Icon>{/if}
                                </div>
                            </h2>
                        </div>

                        <div id="collapseRegFour" class="collapse" aria-labelledby="headingRegFour"
                             data-parent="#accordionReg">
                            <DocumentedProjects bind:this={docuProj}/>
                        </div>
                    </div>
                    <div class="card">
                        <div on:click={handleClickArrow5} class="card-header clickable" id="headingRegFive"
                             style="padding:0;" data-toggle="collapse" data-target="#collapseRegFive"
                             aria-expanded="true" aria-controls="collapseRegFive">
                            <h2 style="margin:0;padding:0;">
                                <button class="btn btn-link dropdown-header">
                                    PROYECTOS DS 19 EN ETAPA DE DECLARACIÓN
                                </button>
                                <div class="sort-arrow">
                                    {#if up5 === false}
                                        <Icon class="arrow-top" icon={faSortUp}></Icon>{/if}
                                    {#if up5 === true}
                                        <Icon class="arrow-bot" icon={faSortDown}></Icon>{/if}
                                </div>
                            </h2>
                        </div>

                        <div id="collapseRegFive" class="collapse" aria-labelledby="headingRegFive"
                             data-parent="#accordionReg">
                            <div class="card-body">
                                <div class="row" style="justify-content: space-evenly;">
                                    {#if proyectsDS19}
                                        {#if proyectsDS19.length > 0}
                                            {#each proyectsDS19 as proyect, i}
                                                <div class="col-4 proyect-textbox">
                                                    <img src={proyect.image} alt="img6" class="proyect-img clickable"
                                                         on:click={handleClickRegisterProyect(proyect)}>
                                                    <div class="row proyect-padding-row">
                                                        <div class="col-9" style="padding-right:0;">
                                                            <p class="proyect-text">Proyecto: {proyect.proyect}</p>
                                                            <p class="proyect-text">Región: {proyect.region}</p>
                                                        </div>
                                                        <div class="col-3 padding-fix-img"
                                                             style="max-width: max-content;">
                                                            <img src="./img/register/icono-ver-mas-ficha.svg" alt=""
                                                                 class="proyect-icon-size clickable"
                                                                 on:click={handleClickRegisterProyect(proyect)}>
                                                        </div>
                                                    </div>
                                                </div>
                                            {/each}
                                        {:else}
                                            <p>No hay proyectos precertificados</p>
                                        {/if}
                                    {:else}
                                        <div class="d-flex justify-content-center">
                                            <div class="spinner-border" role="status"
                                                 style="height: 100px;width: 100px;">
                                                <span class="sr-only">Loading...</span>
                                            </div>
                                        </div>
                                    {/if}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div on:click={handleClickArrow2} class="card-header clickable" id="headingRegTwo"
                             style="padding:0;" data-toggle="collapse" data-target="#collapseRegTwo"
                             aria-expanded="true" aria-controls="collapseRegTwo">
                            <h2 style="margin:0;padding:0;">
                                <button class="btn btn-link dropdown-header">
                                    PROYECTOS PRECERTIFICADOS
                                </button>
                                <div class="sort-arrow">
                                    {#if up2 === false}
                                        <Icon class="arrow-top" icon={faSortUp}></Icon>{/if}
                                    {#if up2 === true}
                                        <Icon class="arrow-bot" icon={faSortDown}></Icon>{/if}
                                </div>
                            </h2>
                        </div>

                        <div id="collapseRegTwo" class="collapse" aria-labelledby="headingRegTwo"
                             data-parent="#accordionReg">
                            <div class="card-body">
                                <div class="row" style="justify-content: space-evenly;">
                                    {#if proyectsInProcess}
                                        {#if proyectsInProcess.length > 0}
                                            {#each proyectsInProcess as proyect, i}
                                                <div class="col-4 proyect-textbox">
                                                    <img src={proyect.image} alt="img6" class="proyect-img clickable"
                                                         on:click={handleClickRegisterProyect(proyect)}>
                                                    <div class="row proyect-padding-row">
                                                        <div class="col-9" style="padding-right:0;">
                                                            <p class="proyect-text">Proyecto: {proyect.proyect}</p>
                                                            <p class="proyect-text">Región: {proyect.region}</p>
                                                        </div>
                                                        <div class="col-3 padding-fix-img"
                                                             style="max-width: max-content;">
                                                            <img src="./img/register/icono-ver-mas-ficha.svg" alt=""
                                                                 class="proyect-icon-size clickable"
                                                                 on:click={handleClickRegisterProyect(proyect)}>
                                                        </div>
                                                    </div>
                                                </div>
                                            {/each}
                                        {:else}
                                            <p>No hay proyectos precertificados</p>
                                        {/if}
                                    {:else}
                                        <div class="d-flex justify-content-center">
                                            <div class="spinner-border" role="status"
                                                 style="height: 100px;width: 100px;">
                                                <span class="sr-only">Loading...</span>
                                            </div>
                                        </div>
                                    {/if}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div on:click={handleClickArrow3} class="card-header clickable" id="headingRegThree"
                             style="padding:0;" data-toggle="collapse" data-target="#collapseRegThree"
                             aria-expanded="true" aria-controls="collapseRegThree">
                            <h2 style="margin:0;padding:0;">
                                <button class="btn btn-link dropdown-header">
                                    PROYECTOS CERTIFICADOS
                                </button>
                                <div class="sort-arrow">
                                    {#if up3 === false}
                                        <Icon class="arrow-top" icon={faSortUp}></Icon>{/if}
                                    {#if up3 === true}
                                        <Icon class="arrow-bot" icon={faSortDown}></Icon>{/if}
                                </div>
                            </h2>
                        </div>

                        <div id="collapseRegThree" class="collapse" aria-labelledby="headingRegThree"
                             data-parent="#accordionReg">
                            <div class="card-body">
                                <div class="row" style="justify-content: space-evenly;">
                                    {#if proyectsCertified}
                                        {#if proyectsCertified.length > 0}
                                            {#each proyectsCertified as proyect, i}
                                                <div class="col-4 proyect-textbox">
                                                    <img src={proyect.image} alt="img6" class="proyect-img clickable"
                                                         on:click={handleClickRegisterProyect(proyect)}>
                                                    <div class="row proyect-padding-row">
                                                        <div class="col-9" style="padding-right:0;">
                                                            <p class="proyect-text">Proyecto: {proyect.proyect}</p>
                                                            <p class="proyect-text">Región: {proyect.region}</p>
                                                        </div>
                                                        <div class="col-3 padding-fix-img"
                                                             style="max-width: max-content;">
                                                            <img src="./img/register/icono-ver-mas-ficha.svg" alt=""
                                                                 class="proyect-icon-size clickable"
                                                                 on:click={handleClickRegisterProyect(proyect)}>
                                                        </div>
                                                    </div>
                                                </div>
                                            {/each}
                                        {:else}
                                            <p>No hay proyectos certificados</p>
                                        {/if}
                                    {:else}
                                        <div class="d-flex justify-content-center">
                                            <div class="spinner-border" role="status"
                                                 style="height: 100px;width: 100px;">
                                                <span class="sr-only">Loading...</span>
                                            </div>
                                        </div>
                                    {/if}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div on:click={handleClickArrow1} class="card-header clickable" id="headingRegOne"
                             style="padding:0;" data-toggle="collapse" data-target="#collapseRegOne"
                             aria-expanded="true" aria-controls="collapseRegOne">
                            <h2 style="margin:0;padding:0;">
                                <button class="btn btn-link dropdown-header">
                                    PROFESIONALES ACREDITADOS COMO ASESORES CVS
                                </button>
                                <div class="sort-arrow">
                                    {#if up1 === true}
                                        <Icon class="arrow-top" icon={faSortUp}></Icon>{/if}
                                    {#if up1 === false}
                                        <Icon class="arrow-bot" icon={faSortDown}></Icon>{/if}
                                </div>
                            </h2>
                        </div>

                        <div id="collapseRegOne" class="collapse show" aria-labelledby="headingRegOne"
                             data-parent="#accordionReg">
                            <div class="card-body">
                                <CVSTable/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<style>

    #collapseRegFour {
        overflow: auto;
    }

    .padding-fix-img {
        padding-right: 0;
        padding-left: 8px;
    }

    .proyect-img {
        width: 320px;
        height: 180px;
    }

    .proyect-text {
        font-family: 'DINPro-Regular';
        font-size: 12pt;
        color: #006937;
        margin: 0;
    }

    .proyect-icon-size {
        height: 30px;
    }

    .proyect-padding-row {
        padding: 5px;
    }

    .proyect-textbox {
        max-inline-size: fit-content;
        background-color: #E5EAF7;
        padding: 0;
    }

    .white-bg {
        background-color: white;
        overflow: hidden;
    }

    .background-right {
        right: 0;
        position: absolute;
        height: 100%;
        /* max-height: 100vh; */
    }

    @media (max-width: 1400px) {
        .card {
            height: auto;
        }

        .disabe-img {
            display: none;
        }

        .padding-fix {
            padding: 0 15px;
        }
    }

    .dropdown-header {
        font-size: 20pt;
        line-height: 21pt;
        text-align: justify;
        color: rgb(0, 99, 175);
        font-family: 'DINPro-Regular';
        padding: 6px 12px 6px 12px;
        white-space: pre-wrap;
    }

    #accordionReg {
        margin: 5vh 0;
    }

    #accordionReg .card {
        margin: 2vh 0;
    }

    .background-right {
        right: 0;
        position: absolute;
        height: 100%;
        max-height: 100vh;
    }

    .padding-fix {
        padding: 0 8px;
    }

    @media (max-width: 1400px) {
        .card {
            height: auto;
        }

        .disabe-img {
            display: none;
        }

        .padding-fix {
            padding: 0 15px;
        }
    }

    .white-bg {
        background-color: white;
        overflow: hidden;
    }

    .card-header {
        background-color: rgb(241, 245, 234);
    }

    .reg-img-base04 {
        position: absolute;
        height: 40vh;
        right: 3vh;
        top: 35vh;
    }

    .sort-arrow {
        margin-left: auto;
    }


    .sort-arrow :global(.arrow-bot) {
        margin-bottom: 13px;
        pointer-events: none;
    }

    .sort-arrow :global(.arrow-top) {
        margin-top: 13px;
        pointer-events: none;
    }

    .flex-arrow .card-header h2 {
        display: flex;
    }

    @media (max-width: 768px) {
        .proyect-textbox {
            margin-bottom: 3vh;
        }
    }

</style>

